import { isEmpty } from 'lodash-es'

// Libs
import {
  updateHandUpList,
  updateMicOnList,
  fetchRoomUserListByUidThunk,
  setIsCountdowning,
  addHandUpItem,
  removeHandUpItem,
  addMicOnItem,
  removeMicOnItem,
  setConnectStatus,
  setHostDisconnectUser,
  setIsShowUserOutPopup,
} from '@/redux/reducers/socket'
import { handleUnPub, handleUnSub } from '@/methods/message/webRTC'
import { getRoomSocketUsers } from '@/methods/message'
import { getRoomHandUpList } from '@/methods/message/getRoomHandUpList'

// Constants
import { WS_EVENT_LIVE_SHOW, HAND_UP_STATUS, CONNECTION_STATUS } from '@/constants/socketEvent'

// Types
import { IMessage } from '../handleMessageReceive'

const live = {
  action({ message, roomId, userToken = '', targetToken = '', socket, rtcData, hostData, isHost, connectStatus }: IMessage) {
    // 上麥事件
    if (message.ssid === WS_EVENT_LIVE_SHOW.handup_list) {
      const actionArray = []

      actionArray.push(updateHandUpList({ handUpList: message.body?.handups || [] }))

      const uids: any = message.body?.handups?.map((item) => item.uid)

      if (isHost && !isEmpty(uids)) {
        actionArray.push(fetchRoomUserListByUidThunk({ uids, roomId }))
      }

      return actionArray
    } else if (message.ssid === WS_EVENT_LIVE_SHOW.connect_list) {
      const actionArray = []
      actionArray.push(updateMicOnList({ micOnList: message.body?.mics || [] }))

      const uids: any = message.body?.mics?.map((item) => item.uid)

      if (isHost && !isEmpty(uids)) {
        actionArray.push(fetchRoomUserListByUidThunk({ uids, roomId }))
      }
      return actionArray
    } else if (message.ssid === WS_EVENT_LIVE_SHOW.handup_report) {
      const actionArray = []

      actionArray.push(handleUpdateHandUpItem({ message }))

      if (isHost) actionArray.push(fetchRoomUserListByUidThunk({ uids: [message?.body?.uid as string], roomId }))

      return actionArray
    } else if (message.ssid === WS_EVENT_LIVE_SHOW.connect) {
      const actionArray = []

      if (isHost) actionArray.push(fetchRoomUserListByUidThunk({ uids: [message?.body?.uid as string], roomId }))

      return actionArray
    } else if (message.ssid === WS_EVENT_LIVE_SHOW.connect_report) {
      getRoomHandUpList({ socket })

      const actionArray = []

      if (message.body.status === HAND_UP_STATUS.ON) {
        if (userToken === message.body.uid) actionArray.push(setIsCountdowning({ isCountdowning: true }))

        actionArray.push(addMicOnItem({ micOnItem: message.body }))
      } else {
        actionArray.push(removeMicOnItem(message.body))

        if (userToken === message.body.uid) {
          actionArray.push(setConnectStatus({ connectStatus: CONNECTION_STATUS.DISCONNECT }))
          actionArray.push(setIsCountdowning({ isCountdowning: false }))
        }

        getRoomSocketUsers({ socket })
      }

      if (message.body.status === HAND_UP_STATUS.OFF) {
        if (message.body.uid === userToken) {
          // 買家收到 host 結束麥
          handleUnPub({ socket, src: userToken })
          handleUnSub({ socket, src: userToken, target: rtcData.token || hostData?.token })
        } else if (message.body.uid === targetToken) {
          // host 收到買家下麥
          actionArray.push(setHostDisconnectUser({ uid: targetToken }))
          actionArray.push(setIsShowUserOutPopup({ isShowUserOutPopup: true }))
        }
      } else if (message.body.status === HAND_UP_STATUS.CONNECT_OFF) {
        if (message.body.uid === targetToken) {
          // host 收到買家斷線
          actionArray.push(setHostDisconnectUser({ uid: message.body.uid }))
          actionArray.push(setIsShowUserOutPopup({ isShowUserOutPopup: true }))
        }
      }

      if (isHost) actionArray.push(fetchRoomUserListByUidThunk({ uids: [message?.body?.uid as string], roomId }))

      return actionArray
    } else if (message.ssid === WS_EVENT_LIVE_SHOW.reset_report) {
      if (connectStatus === CONNECTION_STATUS.CONNECTING) {
        const actionArray = []

        actionArray.push(setConnectStatus({ connectStatus: CONNECTION_STATUS.DISCONNECT }))
        actionArray.push(removeMicOnItem({ uid: userToken }))

        handleUnPub({ socket, src: userToken })
        handleUnSub({ socket, src: userToken, target: rtcData.token || hostData?.token })

        getRoomSocketUsers({ socket })

        return actionArray
      } else {
        const actionArray = []

        actionArray.push(setConnectStatus({ connectStatus: CONNECTION_STATUS.DISCONNECT }))
        actionArray.push(removeMicOnItem({ uid: userToken }))
        getRoomSocketUsers({ socket })
        return actionArray
      }
    }
  },
}

export default live

const handleUpdateHandUpItem = ({ message }: IMessage) => {
  const data: any = message.body
  const { status, ...rest } = data
  if (status === HAND_UP_STATUS.ON) {
    const handUpItem = { ...rest }

    return addHandUpItem({ handUpItem })
  } else {
    return removeHandUpItem(data)
  }
}
